module.exports = __webpack_public_path__ + "static/media/equipment_tab_active.705a427a.svg";